var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCkLogoSide(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.49,
    height: 37.715,
    viewBox: "0 0 62.49 37.715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16319",
    "data-name": "Group 16319",
    transform: "translate(-739.77 -113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5938",
    "data-name": "Path 5938",
    d: "M26.14,10.03h2.348v9.241H26.14V10.03Z",
    transform: "translate(723.294 106.729)",
    fill: "#da291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5939",
    "data-name": "Path 5939",
    d: "M40.657,15.749a2.785,2.785,0,0,0,1.69-2.664c0-2.031-1.428-3.054-3.994-3.054H35.42v9.241h2.348V15.4l2.441,3.871h2.77l-2.323-3.523Zm-2.23-.971h-.658V11.99h.673c.954,0,1.575.423,1.575,1.364a1.4,1.4,0,0,1-1.59,1.424Z",
    transform: "translate(717.446 106.729)",
    fill: "#da291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5940",
    "data-name": "Path 5940",
    d: "M83.452,17.165H86.61v2.106H81.07V10.03h2.382v7.135Z",
    transform: "translate(688.679 106.729)",
    fill: "#da291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5941",
    "data-name": "Path 5941",
    d: "M98.11,10.03H104.1v2.1h-3.646v1.533h3.487V15.6h-3.487v1.563h3.658v2.106H98.11V10.03Z",
    transform: "translate(677.94 106.729)",
    fill: "#da291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5942",
    "data-name": "Path 5942",
    d: "M134.9,8.2l3.236-4.445h-3.325l-3,4.253V3.755h-2.907V13h2.907V8.743l5.17,6.757a8.318,8.318,0,0,1-4.46,1.255,8.164,8.164,0,0,1-8.269-8.383,8.27,8.27,0,1,1,16.539,0,8.532,8.532,0,0,1-1.7,5.19L134.9,8.2h0Z",
    transform: "translate(661.461 113)",
    fill: "#da291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5943",
    "data-name": "Path 5943",
    d: "M5.155,11.775a2.487,2.487,0,0,0-2.474,2.6,2.489,2.489,0,0,0,2.474,2.6A2.585,2.585,0,0,0,7.374,15.68l1.812,1.2A4.673,4.673,0,0,1,5.1,19.157,4.684,4.684,0,0,1,.31,14.372,4.683,4.683,0,0,1,5.1,9.59a4.635,4.635,0,0,1,4.105,2.263L7.352,13.086a2.5,2.5,0,0,0-2.2-1.315",
    transform: "translate(739.571 107.004)",
    fill: "#da291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5944",
    "data-name": "Path 5944",
    d: "M60.255,11.769a2.487,2.487,0,0,0-2.474,2.6,2.489,2.489,0,0,0,2.474,2.6,2.585,2.585,0,0,0,2.219-1.289l1.812,1.2a4.795,4.795,0,0,1-8.876-2.511,4.815,4.815,0,0,1,8.9-2.518l-1.857,1.233a2.5,2.5,0,0,0-2.2-1.315",
    transform: "translate(704.849 107.01)",
    fill: "#da291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5945",
    "data-name": "Path 5945",
    d: "M119.192,55.572V52.84a7.365,7.365,0,0,0-6.442,4.8v-4.5h-2.53v17.22h2.53V63.5c0-4.624,2.4-7.27,5.544-7.795C118.293,55.7,118.648,55.647,119.192,55.572Z",
    transform: "translate(670.309 79.962)",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5946",
    "data-name": "Path 5946",
    d: "M139.777,54.71a7.484,7.484,0,0,0-5.488-1.9c-.769,0-1.749,0-2.578,0v2.47c.81-.082,1.642-.142,2.315-.142,3.188,0,5.03,1.6,5.03,4.662v.532a17.533,17.533,0,0,0-5.192-.735c-4.3,0-7.263,1.934-7.263,5.629V65.3c0,3.53,3.155,5.363,6.343,5.363a7.413,7.413,0,0,0,6.113-2.931v2.563h2.5V59.765a6.862,6.862,0,0,0-1.775-5.063Zm-.692,9.26c0,2.732-2.53,4.628-5.655,4.628-2.3,0-4.275-1.267-4.275-3.433V65.1c0-2.065,1.808-3.463,4.963-3.463a17.224,17.224,0,0,1,4.963.735v1.6Z",
    transform: "translate(659.987 79.981)",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5947",
    "data-name": "Path 5947",
    d: "M8.553,68.4a7,7,0,0,0,5.359-2.432L15.491,67.4a8.718,8.718,0,0,1-7,3.23C3.823,70.628.01,67,.01,61.634c0-5,3.45-8.994,8.151-8.994,5.03,0,7.922,4.062,7.922,9.125,0,.232,0,.5-.033.9H2.569a5.973,5.973,0,0,0,5.984,5.73ZM13.516,60.6c-.3-3.133-2.071-5.8-5.425-5.8-2.925,0-5.163,2.466-5.522,5.8Z",
    transform: "translate(739.76 80.087)",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5948",
    "data-name": "Path 5948",
    d: "M85.064,57.613V39.76h2.53v5.2h5.392v2.263H87.593V57.279a2.529,2.529,0,0,0,2.859,2.863,5.252,5.252,0,0,0,2.467-.6v2.2a6.322,6.322,0,0,1-3.058.734c-2.729,0-4.8-1.364-4.8-4.864Z",
    transform: "translate(686.164 88.14)",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5949",
    "data-name": "Path 5949",
    d: "M45.892,62.082,39.483,53.62h2.892l5.03,6.663,5.03-6.663h2.825l-6.442,8.394,6.7,8.825H52.6l-5.259-7.027L42.045,70.84H39.22l6.672-8.762Z",
    transform: "translate(715.051 79.474)",
    fill: "#ed8b00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCkLogoSide);
export default __webpack_public_path__ + "static/media/ck_logo_side.4c643307fa9fd163d0d4ef2befab95fe.svg";
export { ForwardRef as ReactComponent };